import { makeStateKey, StateKey } from '@angular/core';

export type FeatureStatusMap = Record<string, boolean>;

export const FEATURE_STATUS_STATE_KEY: StateKey<FeatureStatusMap> =
  makeStateKey<FeatureStatusMap>('feature-status');
